import { connect } from 'react-redux';
import HealthNextSteps, { Props } from '../components/HealthNextSteps';
import {
  getSummary,
  getHealthStatements,
  getManagement,
} from '@/pages/CompanyReport/redux/selectors';
import { getPeople } from '@ducks/people/selectors';
import { get } from 'lodash';

interface ContainerProps {
  companyId?: string;
}

const mapStateToProps = (state, ownProps: ContainerProps): Props => {
  const summary = getSummary(state, ownProps);
  const healthStatements = getHealthStatements(state, ownProps);
  const management = getManagement(state, ownProps);
  const people = getPeople(state);
  const leader = people[management.leaderId];
  const isDataMeaningless =
    healthStatements.isHealthAnalysisMeaningless.value === 'Pass';

  return {
    countryISO: summary.countryISO,
    isDataMeaningless,
    scorePast: summary.score.past,
    scoreValue: summary.score.value,
    companyName: summary.shortName,
    scoreFuture: summary.score.future,
    tickerSymbol: summary.tickerSymbol,
    scoreDividend: summary.score.income,
    CEOCompensation: get(leader, 'compensation', null),
    exchangeSymbol: summary.exchangeSymbol,
    industryPrimaryName: summary.industryData.primaryName,
  };
};

export default connect<Props, undefined, ContainerProps>(mapStateToProps)(
  HealthNextSteps
);
